var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBars = function SvgBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.328 2.328a.427.427 0 0 0 .422-.422V.781c0-.21-.21-.422-.422-.422H.422A.427.427 0 0 0 0 .781v1.125c0 .246.176.422.422.422zm0 5.625a.427.427 0 0 0 .422-.422V6.406c0-.21-.21-.422-.422-.422H.422A.427.427 0 0 0 0 6.406v1.125c0 .246.176.422.422.422zm0 5.625a.427.427 0 0 0 .422-.422v-1.125c0-.21-.21-.422-.422-.422H.422a.427.427 0 0 0-.422.422v1.125c0 .246.176.422.422.422z"
  })));
};
export default SvgBars;